import React from 'react'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import Input from './Input'

const datePartsState = state => {
    return dateParts(state.year, state.month, state.date)
}

const minLength = (value) => {
    if (!value) {
        return ''
    }
    value += ''
    return value.length === 1 ? '0' + value : value
}

const isDateValid = (year, month, date) => {
    return year && (year > 1900) && moment(year + '-' + minLength(month) + '-' + minLength(date)).isValid()
}

const dateParts = (year = '', month = '', date = '') => ({
    year,
    month,
    date,
    valid: isDateValid(year, month, date),
})


const formatDate = ({ date, month, year }) => {
    return year + '-' + minLength(month) + '-' + minLength(date)
}

class DateOfBirth extends React.Component {
    constructor (props) {
        super(props)
        this.state = this.parseProps(props)
        this.onChange = this.onChange.bind(this)
        this.onBlur = this.onBlur.bind(this)
    }

    componentWillReceiveProps (props) {
        this.setState(this.parseProps(props))
    }

    parseProps({ object, name }) {
        const date = object[name]
        if (!date) {
            return dateParts()
        }
        const dob = moment(date)

        return dateParts(dob.year(), dob.month() + 1, dob.date())
    }

    onBlur () {
        if (!this.state.valid) {
            return
        }
        this.props.onChange(this.props.name, formatDate(this.state))
    }

    onChange (name, value) {
        this.setState(datePartsState({
            ...this.state,
            [name]: value,
        }))
    }


    render () {
        const { readOnly } = this.props
        const className = this.state.valid ? '' : 'form-error-border'
        return (
            <div className={className}>
                <div className="dob-date">
                    <Input name="date" type="number" readOnly={readOnly} className="form-control" object={this.state} onChange={this.onChange} onBlur={this.onBlur}/>
                </div>
                <div className="dob-month">
                    <Input name="month" type="number" readOnly={readOnly} className="form-control" object={this.state} onChange={this.onChange} onBlur={this.onBlur}/>
                </div>
                <div className="dob-year">
                    <Input name="year" type="number" readOnly={readOnly} className="form-control" object={this.state} onChange={this.onChange} onBlur={this.onBlur}/>
                </div>
            </div>)
    }
}


export default DateOfBirth



// WEBPACK FOOTER //
// ./src/modules/form/component/DateOfBirth.js